// useAuth.ts
import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { IAuthContext } from '../../types/common/AuthType';

export const useAuth = (): IAuthContext => {
  return useContext(AuthContext);
};
